import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../DynamicComp/modal";
import Button from "../DynamicComp/Button";
import axiosClient from "../../global/Globalapi";
import { showAlert } from "../DynamicComp/Alert";

const Admin = () => {
  const [username, setUsername] = useState("");
  const [userpassword, setUserpassword] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
   const baseURL = axiosClient.defaults.baseURL


  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setIsLoading(true);
console.log("Submitting login for:", username, userpassword);
  try {
    const response = await fetch(`${baseURL}/api/userlogin`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, userpassword }),
    });

    const data = await response.json();
    console.log("Login response:", data);
console.log("usertypeid from response:", data.user?.usertypeid);
    if (response.ok && data.message === "Login successful") {

      // alert("Login successful ✅");
      localStorage.setItem("usertypeid", data.user.usertypeid);
      // console.log("usertypeid stored:", data.user.usertypeid);
      localStorage.setItem("username", data.user.username);
      localStorage.setItem("token", data.token);
      
      // alert("Login successful ✅");
              showAlert({ 
          type: "success", 
          title: "Login Successful!",
          message: "You have been logged in successfully.",   
          duration: 3000 
        }, () => {
          navigate("/menu", { replace: true });
        });
      setIsModalOpen(false); // If this closes a modal, it's fine
      navigate("/menu", { replace: true }); // This should trigger navigation
    } else {
      //  alert(data.message || "Invalid credentials ❌");
      showAlert({
          type: 'error',
          message: data.message || 'Invalid credentials ❌',
          title: 'error',
        });

      setError(data.message || "Invalid credentials");
    }
  } catch (err) {
    console.error("Login error:", err);
      showAlert({
        type: 'error',
        message: 'Login failed. Please try again.',
        title: 'Network Error',
      });
    setError("Login failed. Please try again.");
  } finally {
    setIsLoading(false);
  }
};

  const handleClose = () => {
    setIsModalOpen(false);
    navigate("/");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <Modal isOpen={isModalOpen} onClose={handleClose} title="Admin Login">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium">Username</label>
            <input
              type="text"
              placeholder="Enter your Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-1 focus:ring-black"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium">Password</label>
            <input
              type="password"
              placeholder="Enter your Password"
              value={userpassword}
              onChange={(e) => setUserpassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-1 focus:ring-black"
              required
            />
          </div>
          <Button 
            // variant="danger" 
            type="submit" 
            className="w-full"
          >
            Submit
          </Button>
          {showModal && (
            <div className="mt-3 text-red-600 text-center">
              {modalMessage}
            </div>
          )}
        </form>
      </Modal>
    </div>
  );
};

export default Admin;